<template>
    <div class="layout">
        <Header ref="header" /> 
        <div class="main">
            <router-view />
        </div>
        <Footer v-show="access!='userInfo'" />
        <sliderBar />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import sliderBar from '@/components/SliderBar.vue'
export default {
    components: { Header,Footer,sliderBar },
    data() {
        return {
            access:''
        };
    },
    created() {

    },
    mounted() {

    },
    methods: {

    },
    watch: {
		$route: {
			handler(val) {
				this.access = val.meta.access;
			},
			// 深度观察监听
			deep: true,
			immediate: true
		},
	},
};
</script>

<style scoped lang="less">
// .main {
//     margin-top: 64px;
// }
.layout {
    min-width: 1750px;
}
</style>
